module.exports = __webpack_public_path__ + "static/media/si.31fbdc5b.svg";